import {inject, Injectable} from '@angular/core';
import {IItem} from '../../types/IItem';
import {ICompareItem} from '../../types/ICompareItem';
import {AppStore} from '../store/app.store';
import {IAddonForItem} from '../../types/IAddonForItem';
import {environment} from '../../../environments/environment';

type EventMap = {
  'init': {};
  'lookup-form-init': {};
  'compare-items': { items: { good?: ICompareItem; better?: ICompareItem; best?: ICompareItem } };
  'edit-item': { item: IItem };
  'open-item-history': { item: IItem };
  'share-compare-link': { type: 'email' | 'text' | 'print'; link?: string; items: { good?: { item: ICompareItem, addon: IAddonForItem }; better?: { item: ICompareItem, addon: IAddonForItem }; best?: { item: ICompareItem, addon: IAddonForItem } } };
  'save-for-later': { items: { good?: { item: ICompareItem, addons: IAddonForItem }; better?: { item: ICompareItem, addons: IAddonForItem }; best?: { item: ICompareItem, addons: IAddonForItem } }, share_link: string };
  'search-performed': { items: IItem[] };
  'add-item': { item: ICompareItem; addon: IAddonForItem | null; mode: 'quick' | 'quote' | 'quote-po' | 'quote-po-submit' };
};

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private appStore = inject(AppStore);

  emit<T extends keyof EventMap>(type: T, data: EventMap[T]) {
    const message = {type: `tire-finder-${type}`, payload: {...data, cart: this.appStore.cart()}};

    if (!environment.production) console.log(message);

    window.parent.postMessage(message, '*');
  }
}
